import React from 'react';
import { Link } from 'react-router-dom';
import { Tractor, Briefcase, Microscope, Users, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
const pathways = [{
  title: 'Farmers',
  description: 'Access extension services, weather advisories, market prices, and best farming practices.',
  icon: Tractor,
  color: 'bg-uganda-green',
  lightColor: 'bg-green-50',
  textColor: 'text-uganda-green',
  image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=600&h=300&fit=crop',
  link: '/weather-advisory'
}, {
  title: 'Investors',
  description: 'Explore investment opportunities, land policies, export guidelines, and incentives.',
  icon: Briefcase,
  color: 'bg-uganda-yellow',
  lightColor: 'bg-yellow-50',
  textColor: 'text-yellow-700',
  image: 'https://images.unsplash.com/photo-1560493676-04071c5f467b?w=600&h=300&fit=crop',
  link: '/opportunities'
}, {
  title: 'Researchers',
  description: 'Find agricultural data, research publications, statistics, and policy documents.',
  icon: Microscope,
  color: 'bg-slate-700',
  lightColor: 'bg-slate-50',
  textColor: 'text-slate-700',
  image: 'https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?w=600&h=300&fit=crop',
  link: '/sector-statistics'
}, {
  title: 'General Public',
  description: 'Learn about food security, ministry news, events, and public awareness campaigns.',
  icon: Users,
  color: 'bg-uganda-red',
  lightColor: 'bg-red-50',
  textColor: 'text-uganda-red',
  image: 'https://cdn.magicpatterns.com/uploads/8ZjaipUWrJJAPQGRU4dfqV/fdhjkl_(3).jpg',
  link: '/media'
}];
export function UserPathways() {
  return <section className="py-16 bg-uganda-gray" data-id="element-473">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-474">
        <div className="text-center mb-12" data-id="element-475">
          <h2 className="text-3xl font-bold text-uganda-black mb-4" data-id="element-476">
            Information Tailored for You
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-477">
            Select your profile to access personalized dashboards, relevant
            services, and resources designed specifically for your needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-478">
          {pathways.map((pathway, index) => {
          const Icon = pathway.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow border border-gray-100 flex flex-col h-full group" data-id="element-479">
                <div className="h-36 w-full overflow-hidden relative" data-id="element-480">
                  <img src={pathway.image} alt={`${pathway.title} - Uganda agriculture`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-481" />
                  <div className={`absolute inset-0 ${pathway.color} opacity-20`} data-id="element-482" />
                </div>
                <div className={`h-2 w-full ${pathway.color}`} data-id="element-483"></div>
                <div className="p-6 flex flex-col flex-grow" data-id="element-484">
                  <div className={`w-14 h-14 rounded-lg ${pathway.lightColor} ${pathway.textColor} flex items-center justify-center mb-4 -mt-12 relative z-10 border-2 border-white shadow-md`} data-id="element-485">
                    <Icon className="w-7 h-7" data-id="element-486" />
                  </div>
                  <h3 className="text-xl font-bold text-uganda-black mb-3" data-id="element-487">
                    {pathway.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-6 flex-grow" data-id="element-488">
                    {pathway.description}
                  </p>
                  <Link to={pathway.link} className={`inline-flex items-center text-sm font-semibold ${pathway.textColor} hover:opacity-80 transition-opacity mt-auto`} data-id="element-489">
                    Explore Portal <ArrowRight className="w-4 h-4 ml-2" data-id="element-490" />
                  </Link>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}